import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import webPortalServices from "../../services/webPortal.services";
import ServicesBanner from '../assets/img/services-banner.png';
import ServicesAbout from '../assets/img/services-about.png';
import OtherBanner from "../components/OtherBanner";
import ImageWithText from "../components/ImageWithText";
import QuickPoint from "../components/QuickPoint";
import DownloadApp from "../components/DownloadApp";

const DynamicPages = () => {
    const [pageData, setPageData] = useState([])
    let { url } = useParams();
    const navigate = useNavigate();
    function createMarkup() {
        return { __html: pageData?.pageDescription };
    }
    useEffect(() => {
      webPortalServices.dynamicPage(url).then((res) => {
            setPageData(res.data.webNavMenuList)
            if(res.data.webNavMenuList){
            }else{
                // navigate(`/${url}`);
                navigate("/testigo/home")
            }
        })
    }, [])
    return (
        <>
            <OtherBanner
                image={pageData?.bannerImg ? pageData?.bannerImg : ServicesBanner}
                title={pageData?.bannerTitle ? pageData?.bannerTitle:"Lorem Ipsum is simply dummy text"}
                text={pageData?.bannerText ? pageData?.bannerText:"Lorem Ipsum is simply dummy text"}
            />
            <ImageWithText
                class="services-about"
                image={ServicesAbout}
                smallHeading={pageData?.sectionOneSmallHeadin ? pageData?.sectionOneSmallHeadin :"Lorem Ipsum"}
                heading={pageData?.sectionOneHeading ? pageData?.sectionOneHeading:"Lorem Ipsum is simply dummy text"}
                para={pageData?.sectionOneParagraph ? pageData?.sectionOneParagraph:"We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."}
            />

            <div className="dynamic-second_sec">
                <div className="dynamic-header text-center">
                    <h6 className="small-heading aos-init aos-animate" data-aos="fade-up">{pageData?.sectionTwoSmallTitile ? pageData.sectionTwoSmallTitile:'Lorem Ipsum is'}</h6>
                    <h3 className="heading-gradient aos-init aos-animate" data-aos="fade-up">{pageData?.sectionTwoTitile ? pageData?.sectionTwoTitile:'Lorem Ipsum is simply dummy text'}</h3>
                </div>
                <ImageWithText
                    class="dynamicSec-2"
                    image={ServicesAbout}
                    smallHeading={pageData?.sectionTwoSmallHeadin ? pageData?.sectionTwoSmallHeadin:"Lorem Ipsum"}
                    heading={pageData?.sectionTwoHeading ? pageData?.sectionTwoHeading:"Lorem Ipsum is simply dummy text"}
                    para={pageData?.sectionTwoParagraph ? pageData?.sectionTwoParagraph:"We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."}
                />

            </div>

            <QuickPoint
                text="Moving equipment not patients. For more information call us"
                phoneNo="087 056 4412"
            />
            <DownloadApp />
        </>
    )
}

export default DynamicPages;